import type { CheckboxOptionType } from 'antd/lib/checkbox';
import { createContext } from 'react';

interface CheckboxGroupContext {
    name?: string;
    toggleOption?: (option: CheckboxOptionType) => void;
    value?: any;
    disabled?: boolean;
    registerValue: (val: string) => void;
    cancelValue: (val: string) => void;
}

const GroupContext = createContext<CheckboxGroupContext | null>(null);

export default GroupContext;
